import { render, staticRenderFns } from "./pursettlementsubject.vue?vue&type=template&id=0c74700e&scoped=true&"
import script from "./pursettlementsubject.vue?vue&type=script&lang=js&"
export * from "./pursettlementsubject.vue?vue&type=script&lang=js&"
import style0 from "./pursettlementsubject.vue?vue&type=style&index=0&id=0c74700e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c74700e",
  null
  
)

export default component.exports